import { Injectable } from '@angular/core';
import { DataService } from '../../shared-service/data.service';
import { BaseService } from '../../shared-service/base.service';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class CourseCatalogService {
	public courseGamficationPoints: string = '';
	public interestedIdList: Array<string> = [];
	public courseId: string = "";
	public learningType: string = "";

	constructor(private bs: BaseService, private ds: DataService) {
		this.bs.log('info', "Loaded CourseCatalogService");
	}
	subjectToBeObserved!: BehaviorSubject<Object>;
	currentValue: any;

	setObservableValue(val: Object) {
		this.subjectToBeObserved = new BehaviorSubject<object>(val);
		this.currentValue = this.subjectToBeObserved.asObservable();
	}

	setData(key: PropertyKey, data: object) {
		this.ds.setStoreData(key, data);
	}

	changeValue(message: object) {
		this.subjectToBeObserved.next(message);
	}

	//Funcation to activate My learning menu if course is accessed
	activateMyLearningMenu() {
		this.bs.deActivateSubMenus();
		let subMenu = this.bs.subMenu.find((menu:any) => menu['Key'] == "rbkey_MyLrnngLBL");
		subMenu['isSubMenuActive'] = true;
	}

	getAvailableCourseListFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'learning/GetAvailableLearnings', body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getAvailableNewCourseListFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'learning/GetAvailableNewLearnings', body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getAvailableTrendsFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'learning/GetTrends', body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getTrendingCourseListFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'learning/GetAvailableTrendingLearnings', body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}
	getAvailableNewOrTrendCourseListFromServer(body: Object, api: string) {
		let apiEndPoint = "learning/GetAvailableLearnings";
		if (api == "Trending") {
			apiEndPoint = "learning/GetAvailableTrendingLearnings";
		}
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise("***", apiEndPoint, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}


	getAvailableCourseFilterListFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'learning/GetLearningTopics', body).then((data) => {

				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getAvailableCourseKeywordsFilterListFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'learning/GetGlobalTags', body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getLearningTypesFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetMyLearningSummary';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	updateStoreData(key: PropertyKey, data: Object) {
		return this.ds.setStoreData(key, data);
	}

	getStoreData(key: PropertyKey) {
		return this.ds.getDataStoreData(key);
	}

	getLearningDetailFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'learning/GetMyLearningDetail', body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	};

	getLearningNodeDetailFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetMyLearningNodeDetail';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	};

	getAccessAvailableLearning(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/AccessLearning';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	};

	getIltDetailFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetAssignedClassroomTrainingDetail';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	};

	getAccessClassRoomTraining(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/ClassroomTrainingNominate';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	};

	getCourseSpecificAnnouncementDetailFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'SystemAlert/GetAnnouncementDetail';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	};

	setCourseSpecificAnnouncementReadFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'SystemAlert/ReadCourseSpecificAnnouncements';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getCourseSpecificAnnouncementListFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'SystemAlert/GetCourseSpecificAnnouncementList';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	AddRebuseReportComment(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/AddRebuseReportComment';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getconvesationTopics(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'Conversation/GetConversationTopics', body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getCatalogueRatingFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetCatalogueRating';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getMoreComments(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/ShowMoreRatingComments';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}
	updateNoKeyword(data:any) {
		const crsArray = [];
		for (let i = data['availableLearningItems'].length - 1; i >= 0; i--) {
			if (data['availableLearningItems'][i]['Keywords'] == '') {
				data['availableLearningItems'][i]['Keywords'] = this.bs.getResource('rbkey_NoKywrdAvlblLBL');
				crsArray.push(data['availableLearningItems'][i]['CourseID'].toString());
			}
		}
		if (data['Keywords'] == null) {
			data['Keywords'] = [];
			data['Keywords'].push({ Count: crsArray.length, Courses: crsArray, Keyword: this.bs.getResource('rbkey_ct_lblnokwrds') });
		} else {
			data['Keywords'].unshift({ Count: crsArray.length, Courses: crsArray, Keyword: this.bs.getResource('rbkey_ct_lblnokwrds') });
		}
		return data;
	}


	/* Add To Journey */
	setLearningsToMyJourney(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'learning/SetLearningsToMyJourney', body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}
	/* */
	//dynamic fields
	getCourseDynamicListFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'courseDynamic/GetCourseDynamicDetails';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	};

	getNodeMapSkillDetail(CourseID: Object,nodeId:any, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetNodeMapSkillDetail/'+CourseID+'/'+nodeId;
			this.ds.doPostWithPromise(key, controllerMethod, {}).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	};

	getNodeMapDependancySkillDetail(CourseID: Object,nodeId:any,culture:any,corporateID:any, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetNodeMapDependancySkillDetail/'+CourseID+'/'+nodeId+'/'+culture+'/'+corporateID;
			this.ds.doPostWithPromise(key, controllerMethod, {}).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	};
}
